function validate(hotel) {
    let fields = [];
    if(!hotel.unit_type) {
        fields.push('Tipul unitatii este obligatoriu');
    }
    if(!hotel.name) {
        fields.push('Numele unitatii este obligatoriu')
    }
    if(!hotel.description.ro) {
        fields.push('Descrierea unitatii este obligatorie')
    }
    if(!hotel.email) {
        fields.push('Email-ul unitatii este obligatoriu')
    }
    if(!hotel.static.defaults.phone) {
        fields.push('Nr.de telefon a unitatii este obligatoriu')
    }
    if(!hotel.static.contact.person) {
        fields.push('Numele persoanei de contact este obligatoriu')
    }
    if(!hotel.static.contact.email) {
        fields.push('Email-ul persoanei de contact este obligatoriu')
    }
    if(!hotel.static.contact.phone) {
        fields.push('Nr.de telefon a persoanei de contact este obligatoriu')
    }
    if(!hotel.static.geo.region) {
        fields.push('Judetul este obligatoriu')
    }
    if(!hotel.static.geo.city) {
        fields.push('Localitatea este obligatorie')
    }
    if(!hotel.static.geo.address) {
        fields.push('Strada impreuna cu nr este obligatorie')
    }
    if(!hotel.static.geo.postcode) {
        fields.push('Codul postal este obligatoriu')
    }
    if(!hotel.static.defaults.timezone) {
        fields.push('Fusul orar este obligatoriu')
    }
    if(!hotel.static.defaults.currency) {
        fields.push('Moneda este obligatorie')
    }
    if(!hotel.language) {
        fields.push('Limba materna este obligatorie')
    }
    return fields
}

export default {
  validate,
};
